import React, { Component } from 'react';
import '../styles/App.css';

import Addressbar from './Addressbar'
import {Switch, Route, Redirect, useLocation} from "react-router-dom";
import MCAdminPage from "./MCAdminPage";
import DeveloperDashboardPage from "./DeveloperDashboardPage";
import DeveloperInfoPage from "./DeveloperInfoPage";
import MarketInfoPage from "./MarketInfoPage";
import Footer from "./Footer";
import styled from 'styled-components/macro'
import MarketDashboardPage from './MarketDashboardPage';
import SPVWalletPage from "./SPVWalletPage";
import Lato from 'lato-font/css/lato-font.css';

const Main = styled.div`
    min-width: 1440px;
    min-height: 100vh;
    width: 100%;
    margin: 0px;
    padding: 0px;
    overflow-x: hidden;
    background: #F9FAFB;
    font-family: Lato;
    font-style: normal;
`

function App() {
    const location = useLocation();
    return (
     <Main>
       <Addressbar
           medium = {location !== undefined && location.pathname.includes("/developer/")}
           long = {location !== undefined && location.pathname.includes("/spvWallet")}/>
        <Switch>
            <Route exact path="/">
                <Redirect to="loanPool"/>
            </Route>
            <Route exact path="/admin" component={MCAdminPage}/>
            <Route exact path="/loanPool" component={MarketDashboardPage}/>
            <Route exact path="/loanPool/:loanPoolId" component={MarketInfoPage}/>
            <Route exact path="/developerList" component={DeveloperDashboardPage}/>
            <Route path="/developer/:developerId" component={DeveloperInfoPage} />
            <Route exact path="/spvWallet" component={SPVWalletPage} />
        </Switch>
         <Footer/>
     </Main>
    );
}

export default App;
